export default {"src":"/_next/static/media/drip_24.2d1c3954.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};